// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SOrr","type":"styles_type__EKna-","choices":"styles_choices__1Izej"};